{
    "Accessibility Menu": "輔助功能菜單",
    "Reset settings": "重置設定",
    "Close": "關閉",
    "Content Adjustments": "內容調整",
    "Adjust Font Size": "調整字體大小",
    "Highlight Title": "標題高亮",
    "Highlight Links": "連結高亮",
    "Readable Font": "易讀字體",
    "Color Adjustments": "色彩調整",
    "Dark Contrast": "高對比度（黑色）",
    "Light Contrast": "高對比度（白色）",
    "High Contrast": "高對比度",
    "High Saturation": "高飽和度",
    "Low Saturation": "低飽和度",
    "Monochrome": "單色",
    "Tools": "更多設定",
    "Reading Guide": "閱讀尺",
    "Stop Animations": "停止閃動",
    "Big Cursor": "放大滑鼠",
    "Protanopia": "紅色盲",
    "Deuteranopia": "綠色盲",
    "Tritanopia": "藍色盲",
    "Visual & Navigation Aids": "視覺與導航輔助",
    "Additional Tools": "其他工具",
    "Screen Reader": "螢幕閱讀器",
    "Hide Images": "隱藏圖片",
    "Image Tooltips": "圖片提示",
    "Page Structure": "頁面結構",
    "Super Focus": "超級焦點",
    "Magnifier": "放大鏡",
    "Increase Font Size": "增加字體大小",
    "Decrease Font Size": "減小字體大小",
    "Letter Spacing": "字母間距",
    "Line Height": "行距",
    "Font Weight": "字重",
    "Dyslexia Font": "閱讀障礙字體",
    "Language": "語言",
    "Open Accessibility Menu": "打開輔助功能菜單",
    "Accessibility Profiles": "輔助功能檔案",
    "Seizure Safe Profile": "癲癇安全檔案",
    "Stops animations and reduces color saturation.": "停止動畫並降低色彩飽和度。",
    "Blind Profile": "盲人檔案",
    "Activates the screen reader for auditory navigation.": "啟動螢幕閱讀器以進行聽覺導航。",
    "Visually Impaired Profile": "視力障礙檔案",
    "Enhances contrast and readability for low vision.": "提升低視力用戶的對比度和可讀性。",
    "ADHD Friendly Profile": "ADHD 友好檔案",
    "Reduces distractions for better focus.": "減少干擾以更好地集中注意力。",
    "Cognitive & Learning Profile": "認知與學習檔案",
    "Helpful tools for reading and comprehension.": "有助於閱讀和理解的工具。",
    "Motor Impaired Profile": "運動障礙檔案",
    "Optimizes the site for keyboard-only navigation.": "優化網站以支援純鍵盤導航。",
    "Headings": "標題",
    "Landmarks": "地標",
    "Links": "連結",
    "Focus element": "聚焦元素",
    "Visit link": "訪問連結"
}